import sfetch from "./super-fetch";

interface FetchServiceHook<T> {
  get: (url: string) => Promise<T>;
}

const useFetchService = <T>(): FetchServiceHook<T> => {
  const get = (url: string): Promise<T> => {
    return sfetch(url, {
      method: "GET",
    }).then((response) => {
      return response.json() as Promise<T>;
    });
  };

  return {
    get,
  };
};

export default useFetchService;
